import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Survey } from '../../../core/models/survey/survey.model';
import { MedicationType } from '../../../../enums/medication-type.enum';

@Component({
  selector: 'app-summary-form',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './summary-form.component.html',
  styleUrl: './summary-form.component.scss'
})
export class SummaryFormComponent implements OnInit {
  @Output() formSubmitted = new EventEmitter<any>();
  @Input() caseSettingForm!: FormGroup;
  @Input() newPatientInformationForm!: FormGroup;
  @Input() habitsForm!: FormGroup;
  @Input() goalsForm!: FormGroup;
  @Input() diseasesInformationForm!: FormGroup;
  @Input() habitsSurvey!: Survey;
  @Input() omedicationTypes!: { id: string; name: string }[];

  times: { id: string; text: string; value: number }[] = [
    { id: 'morning', text: 'Sabah', value: 1 },
    { id: 'noon', text: 'Öğlen', value: 2 },
    { id: 'evening', text: 'Akşam', value: 3 },
  ];
  medicationForDiabetes: { id: string; text: string; value: number }[] = [
      {
        id: 'oralHypoglycemic',
        text: 'oralHypoglycemic',
        value: MedicationType.ORAL_HYPOGLYCEMIC,
      },
      { id: 'insulin', text: 'insulin', value: MedicationType.INSULIN },
      { id: 'none', text: 'no', value: MedicationType.NONE },
    ];

  ngOnInit(): void {
  }
  

  getMedicationName(id: string): string {
    for (const medication of this.omedicationTypes) {
      if (medication.id === id) {
        return medication.name;
      }
    }
    return 'Unknown'; // Default return value if no match is found
  }
  calculateBMI(): number {
    const weight = this.newPatientInformationForm.get('weight')?.value;
    const height = this.newPatientInformationForm.get('height')?.value;
    if (!weight || !height) return 0;

    const bmi: number = +(weight / Math.pow(height / 100, 2)).toFixed(2);
    return bmi;
  }
  getHabitText(id: string): string {
    if (!this.habitsSurvey || !this.habitsSurvey.questions) return 'Unknown';
    for (const question of this.habitsSurvey.questions) {
      for (const option of question.answerOptions) {
        if (option.id === id) {
          return option.answerText;
        }
      }
    }
    return 'Unknown'; // Default return value if no match is found
  }

  savePreparation(event: Event): void {
    event.preventDefault();
    this.formSubmitted.emit();
  }

  get goalsFormKeys(): string[] {
    return Object.keys(this.goalsForm.controls);
  }
  get patientRelativesControls() {
    return (this.newPatientInformationForm.get('patientRelatives') as FormArray).controls;
  }
  diabetTypeName(value: string): string {

    switch (value) {
      case '20df59e4-2093-4aa3-9325-fe7303019426':
        return 'Option Kimyasal ile indüklenmiş';
      case '2e86798c-b368-4e6b-bbf3-169bba21d94e':
        return 'MODY';
      case '4a8dac50-9b2f-42b1-9445-a55e224e7f2e':
        return 'Ekzokrin pankreas hastalığına sekonder';
      case '8073aa04-b2eb-4746-b637-d1ed2670497c':
        return 'Gestasyonel';
      case 'ccc75276-4b70-4fe3-9349-352c559bacde':
        return 'Prediyabet';
      case 'd38db461-34ed-4a3c-ac39-0a2b8c9f8218':
        return 'LADA';
      case 'f8b9273b-42fb-4ce1-9cfc-f3893001aac8':
        return 'Tip 1';
      case 'fea76797-fba5-480f-b0bc-b3865ef1eec6':
        return 'Tip 2';
      default:
        return 'Bilinmiyor';
    }
  }
}
